import React from "react";
import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";
import { SyncRunStatus } from "../services/model/SyncRun";

interface StatusFilterProps {
  value: SyncRunStatus | "all";
  onChange: (value: SyncRunStatus | "all") => void;
}

const STATUS_OPTIONS: { value: SyncRunStatus | "all"; label: string }[] = [
  { value: "all", label: "All statuses" },
  { value: SyncRunStatus.PENDING, label: "Queued" },
  { value: SyncRunStatus.STARTED, label: "In progress" },
  { value: SyncRunStatus.SUCCESS, label: "Success" },
  { value: SyncRunStatus.PARTIAL, label: "Partial success" },
  { value: SyncRunStatus.FAILED, label: "Failure" },
];

const StatusFilter: React.FC<StatusFilterProps> = ({ value, onChange }) => (
  <div className="flex flex-col gap-xxs">
    <Label htmlFor="status-select" className="text-xs text-greyscale-text-caption">
      Status
    </Label>
    <Select value={value} onValueChange={(v) => onChange(v as SyncRunStatus | "all")}>
      <SelectTrigger id="status-select" className="min-w-[180px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUS_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default StatusFilter;
